import A1 from "./01-min.png";
import A2 from "./02-min.png";
import A3 from "./03-min.png";
import A4 from "./04-min.png";
import A5 from "./05-min.png";
import A6 from "./06-min.png";
import A7 from "./07-min.png";
import A8 from "./08-min.png";
import A9 from "./09-min.png";
import A10 from "./10-min.png";
import A11 from "./11-min.png";
import A12 from "./12-min.png";
import A13 from "./13-min.png";
import A14 from "./14-min.png";
import A15 from "./15-min.png";
import A16 from "./16-min.png";
import A17 from "./17-min.png";
import A18 from "./18-min.png";
import A19 from "./19-min.png";
import A20 from "./20-min.png";
import A21 from "./21-min.png";
import A22 from "./22-min.png";
import A23 from "./23-min.png";
import A24 from "./24-min.png";
import A25 from "./25-min.png";
import A26 from "./26-min.png";
import A27 from "./27-min.png";
import A28 from "./28-min.png";
import A29 from "./29-min.png";
import A30 from "./30-min.png";
import A31 from "./31-min.png";
import A32 from "./32-min.png";
import A33 from "./33-min.png";
import A34 from "./34-min.png";
import A35 from "./35-min.png";
import A36 from "./36-min.png";
import A37 from "./37-min.png";
import A38 from "./38-min.png";
import A39 from "./39-min.png";
import A40 from "./40-min.png";
import A41 from "./41-min.png";
import A42 from "./42-min.png";
import A43 from "./43-min.png";
import A44 from "./44-min.png";
import A45 from "./45-min.png";
import A46 from "./46-min.png";
import A47 from "./47-min.png";
import A48 from "./48-min.png";
import A49 from "./49-min.png";
import A50 from "./50-min.png";
import A51 from "./51-min.png";
import A52 from "./52-min.png";
import A53 from "./53-min.png";
import A54 from "./54-min.png";
import A55 from "./55-min.png";
import A56 from "./56-min.png";
import A57 from "./57-min.png";
import A58 from "./58-min.png";
import A59 from "./59-min.png";
import A60 from "./60-min.png";
import A61 from "./61-min.png";
import A62 from "./62-min.png";
import A63 from "./63-min.png";
import A64 from "./64-min.png";
import A65 from "./65-min.png";
import A66 from "./66-min.png";
import A67 from "./67-min.png";
import A68 from "./68-min.png";
import A69 from "./69-min.png";

export const Tree = Array.of(
  A1,
  A2,
  A3,
  A4,
  A5,
  A6,
  A7,
  A8,
  A9,

  A10,
  A11,
  A12,
  A13,
  A14,
  A15,
  A16,
  A17,
  A18,
  A19,

  A20,
  A21,
  A22,
  A23,
  A24,
  A25,
  A26,
  A27,
  A28,
  A29,

  A30,
  A31,
  A32,
  A33,
  A34,
  A35,
  A36,
  A37,
  A38,
  A39,

  A40,
  A41,
  A42,
  A43,
  A44,
  A45,
  A46,
  A47,
  A48,
  A49,

  A50,
  A51,
  A52,
  A53,
  A54,
  A55,
  A56,
  A57,
  A58,
  A59,

  A60,
  A61,
  A62,
  A63,
  A64,
  A65,
  A66,
  A67,
  A68,
  A69
);
